export default __webpack_public_path__ + "static/pdp--callout-3-84201a2d415a2e29fbd6877eb9cad381.jpg";